import { render, staticRenderFns } from "./EmployeeOptions.vue?vue&type=template&id=07f223ea&scoped=true"
import script from "./EmployeeOptions.vue?vue&type=script&lang=js"
export * from "./EmployeeOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f223ea",
  null
  
)

export default component.exports